import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const AddRetailProduct = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [supplier, setSupplier] =  useState([]);
  const [brands, setBrands] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [formData, setFormData] = useState({
    
    product_name: "",
    rate: "",
    qty_per_box: "",
    stock: "",
  });

  // Fetch Categories & Brands
  useEffect(() => {
    axios
      .post(`${API_BASE_URL}category_list.php`)
      .then((res) => setCategories(res.data.body || []))
      .catch((err) => console.error("Category fetch error:", err));
      axios
      .post(`${API_BASE_URL}supplier_list.php`)
      .then((res) => setSupplier(res.data.body || []))
      .catch((err) => console.error("Category fetch error:", err));
    axios
      .post(`${API_BASE_URL}brand_list.php`)
      .then((res) => setBrands(res.data.body || []))
      .catch((err) => console.error("Brand fetch error:", err));
  }, []);
  console.log(brands);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  // Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const updatedFormData = { ...formData };

      console.log("Sending Data:", updatedFormData);

      const response = await axios.post(
        `${API_BASE_URL}retail_product_add.php`,
        updatedFormData,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.head.code === 200) {
        alert("Product added successfully!");
        navigate("/retailproduct");
      } else {
        alert(response.data.head.msg);
      }
    } catch (error) {
      console.error("Error adding product:", error);
      alert("Failed to add product");
    }
  };

  

  return (
    <>
      <Header />
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <div className="page-body-wrapper">
          <div className="page-body">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="row">
                    <div className="col-sm-12 m-auto">
                      <div className="card">
                        <div className="card-body">
                          <div className="title-header option-title d-sm-flex d-block">
                            <h5>Add Retail Product</h5>
                            <div className="right-options">
                              <ul>
                                <li>
                                  <button
                                    className="btn btn-solid"
                                    onClick={() => window.history.back()}
                                  >
                                    Back
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </div>

                          <form
                            className="theme-form theme-form-2 mega-form"
                            onSubmit={handleSubmit}
                          >
                            <div className="row">

                              {/* Product Name */}
                              <div className="col-md-6 mb-4">
                                <label className="form-label-title">
                                  Product Name
                                </label>
                                <input
                                  required
                                  className="form-control"
                                  type="text"
                                  name="product_name"
                                  placeholder="Enter Product Name"
                                  onChange={handleChange}
                                />
                              </div>
                              <div className="col-md-6 col-sm-6 mb-4">
                                <label className="form-label-title">
                                   Rate
                                </label>
                                 <input
                                  required
                                  className="form-control"
                                  type="text"
                                  name="rate"
                                  placeholder="Enter Rate"
                                  onChange={handleChange}
                                />
                              </div>

                              {/* Other Inputs (4 per row) */}

                              <div className="col-md-6 col-sm-6 mb-4">
                                <label className="form-label-title">
                                  Qty Per Box
                                </label>
                                <div className="d-flex">
                                <input
                                  className="form-control"
                                  type="text"
                                  name="qty_per_box"
                                  placeholder="Enter Qty Per Box"
                                  onChange={handleChange}
                                />
                               
                                </div>
                              </div>
                            <div className="col-md-6 col-sm-6 mb-4">
                                <label className="form-label-title">
                                  Stock
                                </label>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="stock"
                                  placeholder="Enter Stock"
                                  onChange={handleChange}
                                />
                              </div>
                              
                            

                             
                           
                             
                              
                              
                            </div>

                            {/* Buttons */}
                            <div className="card-footer border-0 pb-0 d-flex justify-content-end">
                              <button
                                className="btn btn-primary me-3"
                                type="submit"
                              >
                                Submit
                              </button>
                              <button
                                className="btn btn-outline"
                                onClick={() => window.history.back()}
                              >
                                Cancel
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddRetailProduct;
